import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type SecondFactorEnrollmentStartFailedAction = {
	type: 'SECOND_FACTOR_ENROLLMENT_START_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): SecondFactorEnrollmentStartFailedAction => ({
	type: 'SECOND_FACTOR_ENROLLMENT_START_FAILED',
	payload,
});
